module.exports = __webpack_public_path__ + "docs/Speech for the official launch of the OECD globalrecalls portal.pdf";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=docs/[name].[ext]!./src/assets/docs/Speech for the official launch of the OECD globalrecalls portal.pdf
// module id = 247
// module chunks = 0